import { render, staticRenderFns } from "./LandingList.vue?vue&type=template&id=dea8a378&scoped=true"
import script from "./LandingList.vue?vue&type=script&lang=js"
export * from "./LandingList.vue?vue&type=script&lang=js"
import style0 from "./LandingList.vue?vue&type=style&index=0&id=dea8a378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea8a378",
  null
  
)

export default component.exports